import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";
import { errorFunction } from "../../../Components/Alert/Alert";

// get ApiLogs
export const getDocNumbering = createAsyncThunk("docNumbering/getDocNumbering", async (params, { rejectWithValue }) => {
  const { type, branchId, interBranch = false } = params;
  try {
    const { data } = await API.getDocNumbering({
      type,
      branchId,
      interBranch,
    });
    if (data?.data?.length <= 0) {
      errorFunction("Please setup document numbering for this branch.");
    }

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
